import {Controller} from "@hotwired/stimulus"

export class NestedFormController extends Controller {
	static targets = ["template", "container"]

	add() {
		const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
		this.containerTarget.insertAdjacentHTML("beforeend", html)
	}

	remove(event) {
		event.target.closest("tr").remove()
	}
}